export default abstract class BackendConnect {
  protected headers: Record<string, string> = {};
  private host = document.location.hostname;
  private url: string = `https://api.${this.host}`;
  private fileUrl: string = `https://${this.host}`;  

  constructor(headers: Record<string, string>) {
    this.headers = headers;
  }

  protected setAccessToken(accessToken: string) {
    this.headers.Authorization = `${accessToken}`;
  }

  protected async get(
    path: string,
    params?: Record<string, string | number | boolean | number[]>
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        // Формируем базовый URL
        let endpoint = `${this.url}${path}`;
  
        // Если переданы параметры, добавляем их в строку запроса
        if (params) {
          const queryParams = new URLSearchParams();
  
          // Обрабатываем каждый параметр
          for (const [key, value] of Object.entries(params)) {
            if (Array.isArray(value)) {
              // Если значение — массив, добавляем каждый элемент отдельно
              value.forEach((item) => {
                queryParams.append(`${key}[]`, String(item));
              });
            } else {
              // Если значение не массив, добавляем как есть
              queryParams.append(key, String(value));
            }
          }
  
          // Добавляем параметры к URL
          endpoint += `?${queryParams.toString()}`;
        }
  
        // Выполняем запрос
        const res = await fetch(endpoint, {
          method: "GET",
          credentials: "include",
          headers: this.headers, // Добавляем заголовки
        });
  
        // Обрабатываем ответ
        const json: any = await res.json();
        if (json.error) {
          reject(json.error);
        }
        resolve(json);
      } catch (e: any) {
        console.log(Error(e));
        reject(e);
      }
    });
  }

  protected async file<T>(path: string, body: T, file: File) {
    try {
      const endpoint = `${this.url}${path}`;

      const formData = new FormData();
      formData.append("file", file);

      for (const key in body) {
        if (Object.prototype.hasOwnProperty.call(body, key)) {
          formData.append(key, String(body[key]));
        }
      }

      const response = await fetch(endpoint, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        body: formData,
      });


      if (!response.ok) {
        try {
          const json = await response.json();
          throw new Error(json?.error || "Unknown error occurred");
        } catch (e) {
          throw new Error("Unknown error occurred");
        }
      }

      return await response.json();
    } catch (e: any) {
      throw new Error(e.message || e.toString());
    }
  }

  protected async post<T>(
    path: string,
    body: T,
    method: "POST" | "PUT" | "PATCH" = "POST",
    toFileUrl?: boolean
  ) {
    try {
      const endpoint = `${toFileUrl ? this.fileUrl : this.url}${path}`;

      const response = await fetch(endpoint, {
        method,
        mode: "cors",
        credentials: "include",
        body: JSON.stringify(body),
        headers: new Headers({
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      });


      if (!response.ok) {
        try {
          const json = await response.json();
          throw new Error(json?.error || "Unknown error occurred");
        } catch (e) {
          throw new Error("Unknown error occurred");
        }
      }

      return await response.json();
    } catch (e: any) {
      throw new Error(e);
    }
  }

  protected async delete(
    path: string,
    params?: Record<string, string | number | boolean | number[]>
  ): Promise<any> {
    try {
      // Формируем базовый URL
      let endpoint = `${this.url}${path}`;

      // Если переданы параметры, добавляем их в строку запроса
      if (params) {
        const queryParams = new URLSearchParams();

        for (const [key, value] of Object.entries(params)) {
          queryParams.append(key, String(value));
        }

        endpoint += `?${queryParams.toString()}`;
      }

      // Выполняем запрос
      const response = await fetch(endpoint, {
        method: "DELETE",
        mode: "cors",
        credentials: "include",
        headers: this.headers,
      });

      if (!response.ok) {
        try {
          const json = await response.json();
          throw new Error(json?.error || "Unknown error occurred");
        } catch (e) {
          throw new Error("Unknown error occurred");
        }
      }

      return await response.json();
    } catch (e: any) {
      throw new Error(e.message || e.toString());
    }
  }
}
